export default __webpack_public_path__ + "static/pie-with-variable-radius-3f32c97a7fc390fa2861349441151343.png";